import React from "react";
import HeroSection from "../HeroSection";

function HomeHero() {
  return (
    <HeroSection
      title="Elektricien nodig in Arnhem?"
      description="Laat je gegevens achter en we nemen binnen 24 uur contact met je op voor een vrijblijvend gesprek."
      imageSrc="/images/mark.png"
    />
  );
}

export default HomeHero;
